import { atomWithStorage } from 'jotai/utils';

// Opt-in switch for the KOL workspace UI on production. Off by default, so the
// existing Sanitizer-based dashboard stays as is. Toggled with Ctrl+Alt+K or
// `?newui=1` / `?newui=0` (see useNewUiToggle), remembered in localStorage.
export const NEW_UI_STORAGE_KEY = 'sanr:new-ui';

export const isNewUiAtom = atomWithStorage<boolean>(
  NEW_UI_STORAGE_KEY,
  false,
  undefined,
  { getOnInit: true },
);
